import React, { useState } from 'react';
import { OpenAIService } from '../shared/services/openai.service';

export const OpenAITest: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState<string>('');
  const [error, setError] = useState<string>('');

  const openAIService = new OpenAIService();

  const testConnection = async () => {
    setIsLoading(true);
    setError('');
    setResult('');

    try {
      // Verificar si está configurado
      if (!openAIService.isConfigured()) {
        throw new Error('OpenAI service is not configured');
      }

      // Texto de prueba simple para procesar
      const testBankText = `
        BANCO GALICIA
        EXTRACTO BANCARIO
        Período: 01/01/2024 - 31/01/2024
        
        MOVIMIENTOS:
        15/01/2024 - Transferencia recibida - $50000 - SALARIO EMPRESA XYZ
        18/01/2024 - Compra en supermercado - $-8500 - MERCADO LIBRE SA
        20/01/2024 - Pago de servicios - $-3200 - EDENOR
        25/01/2024 - Transferencia enviada - $-15000 - ALQUILER DEPTO
      `;

      const processedData = await openAIService.processBankDocument(testBankText);
      
      setResult(JSON.stringify(processedData, null, 2));
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error desconocido');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-bold mb-4 text-gray-800">
          🧪 Prueba de OpenAI Service
        </h2>
        
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">
            Estado del servicio: {openAIService.isConfigured() ? '✅ Configurado' : '❌ No configurado'}
          </p>
          <p className="text-sm text-gray-600 mb-4">
            Modelo: {import.meta.env.VITE_OPENAI_MODEL || 'No especificado'}
          </p>
        </div>

        <button
          onClick={testConnection}
          disabled={isLoading}
          className="bg-blue-500 hover:bg-blue-600 disabled:bg-gray-400 text-white px-4 py-2 rounded-lg font-medium transition-colors"
        >
          {isLoading ? '🔄 Procesando...' : '🚀 Probar Conexión'}
        </button>

        {error && (
          <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
            <h3 className="text-red-800 font-medium mb-2">❌ Error:</h3>
            <pre className="text-red-700 text-sm whitespace-pre-wrap">{error}</pre>
          </div>
        )}

        {result && (
          <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
            <h3 className="text-green-800 font-medium mb-2">✅ Resultado procesado:</h3>
            <pre className="text-green-700 text-sm whitespace-pre-wrap overflow-auto max-h-96">{result}</pre>
          </div>
        )}

        <div className="mt-6 p-4 bg-gray-50 border border-gray-200 rounded-lg">
          <h3 className="text-gray-800 font-medium mb-2">ℹ️ Información:</h3>
          <ul className="text-sm text-gray-600 space-y-1">
            <li>• Esta prueba usa el nuevo formato argentino de procesamiento</li>
            <li>• El modelo GPT-5-nano debería procesar el texto bancario</li>
            <li>• El resultado incluye ingresos, egresos y resumen</li>
            <li>• Se mantiene compatibilidad con el formato anterior</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OpenAITest;